import { GzRmTopVulnerabilitiesSeverityWidgetWebComponent } from './component/GzRmTopVulnerabilitiesSeverityWidgetWebComponent';

export { GzRmTopVulnerabilitiesSeverityWidgetWebComponent };
